module.exports = __webpack_public_path__ + "package/Parchment.Registration/web/react/ThirdPartyRegistration/media/credential_request_authorization_form.pdf";